import { render, staticRenderFns } from "./AvailableGiftCard.vue?vue&type=template&id=320b970e&scoped=true&"
import script from "./AvailableGiftCard.vue?vue&type=script&lang=ts&"
export * from "./AvailableGiftCard.vue?vue&type=script&lang=ts&"
import style0 from "./AvailableGiftCard.vue?vue&type=style&index=0&id=320b970e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b970e",
  null
  
)

export default component.exports